// extracted by mini-css-extract-plugin
module.exports = {"categoriesSwitcher":"CategoriesSwitcher_categoriesSwitcher__1Yo_5","radioBtn":"CategoriesSwitcher_radioBtn__yqFRP"};